import { UserRolesEnum } from '../enums/user-roles.enum';
import { get } from '../services/storage';

const FOLLOW_UP_REWRITE_ROLES = new Set<string>([
  UserRolesEnum.brokerAdmin,
  UserRolesEnum.brokerAnalyst,
  UserRolesEnum.accountManager,
  UserRolesEnum.claimAnalyst,
  UserRolesEnum.cancelationAnalyst,
]);

export const canUseFollowUpRewrite = (role?: string | null): boolean => {
  const currentRole = role === undefined ? get('role') : role;
  return currentRole != null && FOLLOW_UP_REWRITE_ROLES.has(currentRole);
};
